import { render, staticRenderFns } from "./detail_wechat.vue?vue&type=template&id=c5708154&scoped=true"
import script from "./detail_wechat.vue?vue&type=script&lang=js"
export * from "./detail_wechat.vue?vue&type=script&lang=js"
import style0 from "./detail_wechat.vue?vue&type=style&index=0&id=c5708154&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5708154",
  null
  
)

export default component.exports